module.exports = __webpack_public_path__ + "img/dxyw1.83ce8e4b.png";